
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import { getFormState, parseSavedData } from '../../../helpers/form';
import dayjs from 'dayjs';
import {
    getUsers,
    getEntities,
    getRoles,
    getMyState,
  } from "../../../state/user/actions";

const API_HOST = CONFIG.modules['accounts'].host

const dateColumns = [
    { id: 'createdAt', label: 'Created At', minWidth: 60, format:(data, row)  => {
        return data? dayjs(data).format('DD-MM-YYYY hh:mm:ss'):''
    }},
    { id: 'updatedAt', label: 'Updated At', minWidth: 60, format:(data, row)  => {
        return data? dayjs(data).format('DD-MM-YYYY hh:mm:ss'):''} }
]

const items = {
    'Priviledges': {
        name: 'Priviledges'
    },
    'Roles': {
        name: 'Roles'
    },
    'FieldTypes': {
        name: 'FieldTypes'
    },
    'Validations': {
        name: 'Validations'
    },
    // 'Fields': {
    //     name: 'Fields'
    // },
   
}

const columnsMap = {
    'Validations': [
        { id: 'type', label: 'Name', minWidth: 170, format: (data, row)=> {
            return (typeof data == 'string')?data:''
        }  },
        { id: 'regex', label: 'Regex', minWidth: 170 },
        ...dateColumns
     
    ],
    'Priviledges': [
        { id: 'name', label: 'Name', minWidth: 170 },
        ...dateColumns
    ],
    'Roles': [
        { id: 'name', label: 'Name', minWidth: 170 },
      
        {
            id: 'priviledges', label: 'Priviledges', minWidth: 170, format: (data, row, i,map) => {
                const m = map.Priviledges
                return (data || []).map(d => (m&&m[d]?m[d].name:d)).join(",")
            }
        },
        ...dateColumns,
       
    ],
    'FieldTypes': [
        { id: 'type', label: 'Name', minWidth: 170, format: (data, row)=> {
            return (typeof data == 'string')?data:''
        } },
        ...dateColumns
    ],
    'Fields': [
        { id: 'name', label: 'Name', minWidth: 70 },
        { id: 'keyId', label: 'Key', minWidth: 70 },
        { id: 'type', label: 'Type', minWidth: 60 , format: (data, row, i, map) => {
            const m = map.FieldTypes
            return data&&m[data]?m[data].type:''
        }},
        { id: 'validations', label: 'Validations', minWidth:120 , format:(data, row, i, map)=>{
            const m = map.Validations
            return (data || []).map(d => (m&&m[d]?m[d].type:d)).join(",")
        }},
        { id: 'status', label: 'Status', minWidth: 60 },
        { id: 'required', label: 'Required', minWidth: 60, format: (data, row) => {
            return data?'YES':'NO'
        }  },
        ...dateColumns
    ]
}

const fieldsMap = {
    'Validations': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'type'
        },
        {
            type: 'text',
            label: 'Regex',
            required: true,
            name: 'regex'
        },
    ],
    'Fields': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'text',
            label: 'Key',
            required: true,
            name: 'keyId'
        },
        {
            type: 'select',
            label: 'Type',
            required: true,
            name: 'type',
            option: { key: 'FieldTypes', value: '_id', label: 'type' }
        },
        {
            type: 'select',
            label: 'Validations',
            required: true,
            multiple: true,
            name: 'validations',
            option: { key: 'Validations', value: '_id', label: 'type' }
        },
        {
            type: 'select',
            label: 'Status',
            required: true,
            name: 'status',
            option: { key: 'field_status', value: '_id', label: 'name' }
        },
        {
            type: 'switch',
            label: 'Required',
            required: true,
            name: 'required',
            defaultValue: false
        },
    ],
    'FieldTypes': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'type'
        },
    ],
    'Priviledges': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
    ],
    'Roles': [
        {
            type: 'text',
            label: 'Name',
            required: true,
            name: 'name'
        },
        {
            type: 'select',
            label: 'Priviledges',
            required: true,
            name: 'priviledges',
            multiple: true,
            option: { key: 'Priviledges', value: '_id', label: 'name' }

        }
    ]
}

const fields = [,]



export const AdminEntities = (props) => {

    const { roles, user, users, Designations, Departments, Languages, 
        Districts, Priviledges, Hierarchies, FieldTypes, Validations, map } = useSelector((state) => (state.user || {}))
    const [active, setActive] = useState('Priviledges')
    const [data, setData] = useState([])
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('new')
    const [extraFields, setExtraFields] = useState({ priviledges: [] })
    const [saved, setSaved] = useState(null);
    const [index, setIndex] = useState(null);
    const [openConfirm, setOpenConfirm] = useState(false)
    const [formData, setFormData] = useState(getFormState(fieldsMap[active]))
    const dispatch = useDispatch();


    useEffect(() => {
        setData([])
        axios.get(API_HOST + '/entity?entityName=' + active).then((resp) => {
            if (resp.data && resp.data.success) {
                setData(resp.data.data)
            }
        }).catch((e) => {
            console.log(e)
        })
    }, [active])

    useEffect(()=> {
        // console.log(active, map)
    },[map])

    const handleSubmit = () => {
        axios.post(API_HOST + '/entity', {
            entityName: active,
            payload: { ...formData }
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                setData([resp.data.data, ...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleEdit = () => {
        const payload = { ...formData }

        axios.put(API_HOST + '/entity', {
            entityName: active,
            payload,
            id: saved._id
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpen(false)
                data[index] = resp.data.data
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleDelete = () => {
        axios.delete(API_HOST + '/entity?entityName=' + active + '&ids=' + saved._id).then((resp) => {
            if (resp.data && resp.data.success) {
                setOpenConfirm(false)
                data.splice(index, 1)
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    useEffect(()=> {
        if(active == 'Roles') {
            dispatch(getRoles());
        } else{
            dispatch(getEntities(active));
        }
    },[data])


    return (
        <>

            <Tabs items={items} active={active} onChange={(key) => {
                setActive(key)
            }} />
            <ToolBar name={active} buttons={[
                {
                    name: 'Add new',
                    onClick: () => {
                        setAction('new')
                        setOpen(true)
                        setFormData(getFormState(fieldsMap[active]))

                    }
                }
            ]} />
            <Box sx={{ mt: 2 }}>
                {
                    data.length>0 &&
                
                <Grid id={`${active}-table`} data={data} columns={columnsMap[active]} map={map}
                    actions={[
                        {
                            name: 'Edit',
                            onClick: (id) => {


                                setIndex(id)
                                setAction('edit')
                                setOpen(true)
                                const newData = { ...data[id] }
                                const parsedData = { ...(parseSavedData(newData, fieldsMap[active])) }
                                setFormData(parsedData)
                                setSaved(data[id])
                            }
                        },
                        // {
                        //     name: 'Delete',
                        //     onClick: (id) => {
                        //         setIndex(id)
                        //         setSaved(data[id])
                        //         setOpenConfirm(true)
                        //     }
                        // }
                    ]}></Grid>
                }
            </Box>
            <Modal open={open}
                handleClose={() => { setOpen(false) }}
                head={`${action == 'new' ? 'Add' : 'Edit'} ${active}`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpen(false)
                        }
                    },
                    {
                        name: action == 'new' ? 'Create' : 'Save',
                        onClick: () => {
                            switch (action) {
                                case 'new':
                                    handleSubmit()
                                    break;
                                case 'edit':
                                    handleEdit()
                                    break;
                                default: break;
                            }
                        }
                    }
                ]}

            >
                {
                    action == 'edit' &&
                    <Typography variant='p' color="grey">{
                        'ID: ' + saved._id
                    }</Typography>
                }
                {
                    Array.isArray(fieldsMap[active]) &&
                    <Box sx={{ mt: 2 }}>
                        <FormA fields={fieldsMap[active]}
                            data={{ roles, Designations, Districts, Languages, Departments, users, Hierarchies, Priviledges, FieldTypes, Validations, field_status: [
                                {
                                    _id: 'active',
                                    name: 'Active'
                                },
                                {
                                    _id: 'disabled',
                                    name: 'Disabled'
                                },
                            ] }}
                            onChange={(name, value, multiple) => {
                                formData[name] = value
                                setFormData({ ...formData })
                            }}
                            state={formData || {}}
                        />
                    </Box>
                }

            </Modal>

            <Modal open={openConfirm}
                handleClose={() => { setOpen(false) }}
                head={`${'Delete'} ${active}`}
                desc={`Please confirm to delete the following ${active}?`}
                buttons={[
                    {
                        name: 'Cancel',
                        onClick: () => {
                            setOpenConfirm(false)
                        }
                    },
                    {
                        name: 'Delete',
                        onClick: () => {
                            handleDelete()
                        }
                    }
                ]}

            >
                {
                    saved &&
                    <Box>
                        <Typography variant='p' color="grey">{'ID: ' + saved._id}</Typography><br></br>
                        <Typography variant='p' color="grey">{'Name: ' + saved.name}</Typography>
                    </Box>
                }

            </Modal>

        </>
    )
}